const localAppUrl = "http://contractrabbit.local.com:3000";
/**
 * @param {{ explicitPublicUri?: string; vercelUrl?: string }} params
 * @returns {string}
 */
export function resolvePublicAppUrl({ explicitPublicUri, vercelUrl }) {
    const trimmedExplicitUri = explicitPublicUri?.trim();
    if (trimmedExplicitUri) {
        return trimmedExplicitUri.replace(/\/+$/, "");
    }
    const trimmedVercelUrl = vercelUrl?.trim();
    if (trimmedVercelUrl) {
        return `https://${trimmedVercelUrl.replace(/^https?:\/\//, "").replace(/\/+$/, "")}`;
    }
    return localAppUrl;
}
